import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.header`
	background-color: ${helpers.color.pageHeader};
	display: flex;
	flex-direction: column;
	grid-area: header;
	align-items: center;

	height: 84px;
`
